import * as React from "react";

const FilterIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="17"
    fill="none"
    viewBox="0 0 35 22"
  >
    <path
      fill="#fff"
      d="M2.932 4.07q-.882 0-1.47-.508Q.9 3.028.9 2.198q0-.855.561-1.363Q2.051.3 2.932.3H32.08q.883 0 1.444.535.588.508.589 1.363 0 .83-.589 1.364-.56.508-1.444.508zm3.958 8.852q-.883 0-1.47-.508-.562-.51-.562-1.364t.561-1.364q.588-.535 1.471-.535h21.233q.883 0 1.444.535.588.508.588 1.364 0 .855-.588 1.364-.562.508-1.445.508zm4.145 8.878q-.91 0-1.47-.508-.562-.535-.562-1.364 0-.855.561-1.364.562-.535 1.47-.535h12.97q.883 0 1.444.535.562.508.562 1.364 0 .829-.562 1.364-.56.508-1.444.508z"
    ></path>
  </svg>
);

export default FilterIcon;